module.exports = __webpack_public_path__ + "static/media/terms.8b698b77.svg";